// imports
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

// styles
import "./Navbar.css";

// assets
import MenuIcon from "../assets/menu_black_24dp.svg";
import CloseIcon from "../assets/close_black_24dp.svg";

export default function Navbar() {
    const [menuVisible, setMenuVisible] = useState(false);

    const handleResize = (e) => {
        if (window.innerWidth > 767) {
            setMenuVisible(false);
        }
    };

    useEffect(() => {
        window.addEventListener("resize", handleResize);

        // cleanup this component
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const toggleMenu = function () {
        setMenuVisible((prev) => !prev);
    };

    return (
        <div className="navbar">
            <nav>
                <h1>
                    <Link to="/">la Flor de la Vida</Link>
                </h1>
                <img
                    src={menuVisible ? CloseIcon : MenuIcon}
                    alt="menu"
                    className="icon"
                    onClick={toggleMenu}
                />
                <ul
                    className={`menu ${menuVisible ? "visible" : "hidden"}`}
                    onClick={toggleMenu}
                >
                    <Link to="/">
                        <li>INICIO</li>
                    </Link>
                    <Link to="/sobre_mi">
                        <li>SOBRE MÍ</li>
                    </Link>
                    <Link to="/mi_vision">
                        <li>MI VISIÓN</li>
                    </Link>
                    <Link to="/canalizacion">
                        <li>CANALIZACIÓN</li>
                    </Link>
                    <Link to="/reiki">
                        <li>REIKI</li>
                    </Link>
                    <Link to="/contacto">
                        <li>CONTACTO</li>
                    </Link>
                </ul>
            </nav>
            <div className="pseudo-margin"></div>
        </div>
    );
}
